import type { IconWrapperProps } from '@/core/components/icon/icon-wrapper';
import type { SVGIconProps } from '@/core/components/icon/svg-icon';

import { IconWrapper } from '@/core/components/icon/icon-wrapper';
import SVGIcon from '@/core/components/icon/svg-icon';

export default function PhoneIcon(props: SVGIconProps & IconWrapperProps) {
    return (
        <IconWrapper {...props}>
            <SVGIcon
                {...props}
                viewBox={'0 0 18 18'}
            >
                <path
                    d={
                        'M23.71 20.053a1.005 1.005 0 0 0 0-.27 2.242 2.242 0 0 0-.97-.68l-.686-.382-.81-.444-.687-.394-.318-.222a3.398 3.398 0 0 0-.454-.271.769.769 0 0 0-.405-.111 1.031 1.031 0 0 0-.638.37 6.18 6.18 0 0 0-.7.801 7.05 7.05 0 0 1-.674.802.975.975 0 0 1-.588.37.724.724 0 0 1-.283-.062l-.257-.11-.295-.198-.245-.148a13.717 13.717 0 0 1-3.005-2.232c-.87-.9-1.619-1.912-2.22-3.022l-.172-.271-.184-.309-.11-.259a.735.735 0 0 1-.061-.283.981.981 0 0 1 .368-.592 7.03 7.03 0 0 1 .797-.679c.282-.21.54-.444.785-.69a1.04 1.04 0 0 0 .368-.642.78.78 0 0 0-.086-.37 3.513 3.513 0 0 0-.282-.456l-.221-.32-.393-.679-.453-.814-.38-.703a2.25 2.25 0 0 0-.638-.974.989.989 0 0 0-.27 0 4.35 4.35 0 0 0-.896.123 4.6 4.6 0 0 0-.92.247 3.45 3.45 0 0 0-1.349 1.554 4.96 4.96 0 0 0-.65 2.392 6.257 6.257 0 0 0 0 .679c.037.246.086.493.16.74.11.271.184.468.245.604l.245.715.233.63c.27.789.626 1.54 1.055 2.244a19.251 19.251 0 0 0 2.76 3.391 19.189 19.189 0 0 0 3.373 2.775c.7.432 1.447.79 2.232 1.061l.626.234.711.247.601.185c.246.074.491.123.736.16.221.013.454.013.675 0a4.893 4.893 0 0 0 2.38-.653 3.448 3.448 0 0 0 1.545-1.295c.123-.284.208-.568.282-.864a4.42 4.42 0 0 0 .123-.9v-.025Z'
                    }
                    transform={'translate(-5.719 -5.8)'}
                />
            </SVGIcon>
        </IconWrapper>
    );
}

export { PhoneIcon };
